module.exports = __webpack_public_path__ + "img/gb9126_3_b.prt.030b452e.jpg";